import React from "react";

function ZigZag() {
  return <span className="zigzag">^^^^</span>;
}

export default ZigZag;
